export const SIGN_REQUEST_PENDING = "SIGN_REQUEST_PENDING";
export const SIGN_REQUEST_FAILURE = "SIGN_REQUEST_FAILURE";
export const SIGN_REQUEST_SUCCESS = "SIGN_REQUEST_SUCCESS";
